import controller from './wf-node-select.controller';
import template from './wf-node-select.html';

export default {
	controller,
	template,
	bindings: {
		data:     '<ngModel',
		disabled: '<ngDisabled',
		form:     '<?',
		index:    '<?',
		isa:      '<?',
		actions:  '<?modelActions',
		options:  '<?',
	},
	require:  {
		ngModelCtrl: '?ngModel',
		kformCtrl:   '^^?kform',
	},
};
